import { render, staticRenderFns } from "./ModalNtrPrasymasPagrindas.vue?vue&type=template&id=23a1671e&scoped=true&"
import script from "./ModalNtrPrasymasPagrindas.vue?vue&type=script&lang=js&"
export * from "./ModalNtrPrasymasPagrindas.vue?vue&type=script&lang=js&"
import style0 from "./ModalNtrPrasymasPagrindas.vue?vue&type=style&index=0&id=23a1671e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a1671e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardActions,VCardText,VCardTitle,VCol,VDialog,VRow,VSpacer})
